"use client";
import { usePathname } from "next/navigation";
import EventDetailsSkeleton from "~/components/events/EventDetailsSkeleton";
import RiverLoading from "~/components/themed/RiverLoading";

export default function Loading() {
    const path = usePathname();

    if (path?.split("/").length === 3) return <EventDetailsSkeleton />;
    return <RiverLoading />;
}
